import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";
import {
  UpdateFieldTypePayload,
  FieldTypeResponseData,
} from "../../types/field-type";

const updateFieldType = async (
  id: string,
  payload: UpdateFieldTypePayload,
): Promise<FieldTypeResponseData> => {
  const { data } = await createApiWithPath("crm").put(
    `/field-types/${id}`,
    payload,
  );
  return data;
};

export const useUpdateFieldType = () => {
  return useMutation(
    ({ id, payload }: { id: string; payload: UpdateFieldTypePayload }) =>
      updateFieldType(id, payload),
  );
};
